<div class="coverage-toggle" [class.coverage-toggle--border-bottom]="group.hasBorder">
    <div class="coverage-toggle__left-column">
        <div class="coverage-toggle__checkbox">
            <wuc-input-checkbox [(ngModel)]="value.enabled"
                                (ngModelChange)="toggle()"
                                [name]="group.id">&nbsp;
            </wuc-input-checkbox>
        </div>
        <div class="coverage-toggle__title">
            <label [for]="group.id">{{ group?.data?.title }}</label>
            <div class="coverage-toggle__group-choices">
                <wuc-input-radio-card *ngFor="let input of group.inputs" [(ngModel)]="value.choice"
                                      [value]="input.coverageIds" [id]="input.id" (ngModelChange)="setSelected(input)">
                    {{ input?.data?.title }}
                </wuc-input-radio-card>
            </div>
        </div>
    </div>
    <div class="coverage-toggle__right-column">
        <wuc-link type="secondary"
                  *ngIf="group?.data?.body || group?.data?.tabs"
                  (clicked)="group.id === coverageGroupIdEnum.RoadsideAssistance ? openModal(group.id) : displayInformation(group?.data)">
            meer info
        </wuc-link>
        <wuc-price *ngIf="price" [price]="price"></wuc-price>
    </div>
</div>
